import Axios from 'axios'

// if(process.env.NODE_ENV != "dev"){//联调时用代理，不然跨域
//   Axios.defaults.baseURL = process.env.VUE_APP_API;//全局环境变量
// }
Axios.defaults.baseURL = process.env.VUE_APP_API;//全局环境变量
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
Axios.interceptors.request.use(config => {
  if(config.url == '/device'){
    config.baseURL = 'http://device.malink.cn/'
  }
  return config
})
// 添加响应拦截器
Axios.interceptors.response.use(response => {
  if(response.data['code']==0){
    return response.data;
  }else{
    router.replace({
      path: '/error',
      query: {
        code: response.data['code'],
        msg: response.data['msg']
      }
    });
  }
}, error => {
  try {
    switch (error && error.response && error.response.status) {
      case 403:
        alert('禁止访问');
        break;
      case 404:
        alert('接口不存在');
        break;
      case 405:
        alert('不允许的HTTP请求方法');
        break;
      case 500:
        alert('服务器错误');
        break;
      default:
        error && error.response && alert('服务器连接异常，烦请客服' + error.response.status);
        break;
    }
    return Promise.reject(error)
  } catch (error) {
    return Promise.reject(error)
  }
})
export default Axios
